export default "__VITE_ASSET__dee72a94__"